import { render, staticRenderFns } from "./OderDetails.vue?vue&type=template&id=62cad149&"
import script from "./OderDetails.vue?vue&type=script&lang=js&"
export * from "./OderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports